<template>
  <tr v-for="refinement,index in group" :key="refinement.id">
    <td>
      {{ (inEnglish.value) ? refinement.booth_refinement.name_en : refinement.booth_refinement.name }}
    </td>
    <template v-if="index === 0">
      <td :rowspan="group.length">
        <span class="text-primary cursor--pointer" @click="show">
          <i class="fa fa-info-circle"></i> {{ articleName }}
        </span>
      </td>
      <td v-if="cloud.status < PRINT_CLOUD_STATUS_FINISHED" :rowspan="group.length">
        <span v-if="configuration.is_logo_print && configuration.upload !== null && configuration.upload.file_exists"
          class="text-primary cursor--pointer"
          @click="download">
          <i class="fa fa-download"></i> {{ configuration.upload.original_name }}
        </span>

        <template v-if="configuration.is_logo_print && configuration.upload !== null  && !configuration.upload.file_exists">
          <span class="text-primary">{{ configuration.upload.original_name }}</span><br>
          <span  class="mr-2 bg-danger">
            <i class="fa fa-warning text-danger"></i> {{ $t('configurator.labels.file_missing') }}
          </span>
        </template>
        
        <span v-if="configuration.is_logo_print && configuration.upload === null" class="mr-2 bg-warning">
          <i class="fa fa-warning text-warning"></i> {{ $t('configurator.labels.upload_missing') }}
        </span>
        <span v-if="!configuration.is_logo_print">
          {{ configuration.label }}
        </span>
      </td>
      <td v-else :rowspan="group.length">
        <span v-if="configuration.is_logo_print && configuration.upload !== null" class="text-primary">
          {{ configuration.upload.original_name }}
        </span>
        <span v-if="configuration.is_logo_print && configuration.upload === null" class="mr-2 bg-warning">
          <i class="fa fa-warning text-warning"></i> {{ $t('configurator.labels.upload_missing') }}
        </span>
        <span v-if="!configuration.is_logo_print">
          {{ configuration.label }}
        </span>
      </td>
    </template>
  </tr>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { PRINT_CLOUD_STATUS_FINISHED } from '@/constants'

const store = useMainStore()
// define props
const props = defineProps({
  group: {
    type: Array,
    required: true
  }
})
// define emits
const emit = defineEmits(['download', 'show'])
// define computed props
const locale = computed(() => store.settings.locale)
const cloud = computed(() => store.tmp.cloud)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const article = computed(() => {
  return props.group[0].article
})

const articleName = computed(() => {
  return (inEnglish.value)
    ? article.value.name_en
    : article.value.name
})

const configuration = computed(() => {
  return props.group[0].configurations[0]
})
// define methods
const show = () => {
  emit('show', article.value)
}

const download = () => {
  emit('download', configuration.value.upload)
}
</script>